var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clients-editor-container" },
    [
      _c(
        "el-row",
        {
          staticStyle: {
            background: "#fff",
            padding: "16px 16px 0",
            "margin-bottom": "32px",
          },
        },
        [
          _c("div", { staticClass: "order-table-title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
            _c("span", { staticStyle: { float: "right" } }, [
              _vm._v(_vm._s(_vm.total) + " Clients"),
            ]),
          ]),
          _c("ClientsTable", {
            attrs: {
              list: _vm.list,
              listLoading: _vm.listLoading,
              total: _vm.total,
            },
            on: { handleDelete: _vm.handleDelete },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }